<template>
  <div class="header-dash">
    <el-row>
      <el-col
        :span="8"
        class="card">
        <el-button circle="">{{ initialLetter }}</el-button>
        <div class="data-item">
          <h4>{{ profile.name }}</h4>
          <span>{{ profileRole }}</span>
          <p>{{ dealer }}</p>
        </div>
      </el-col>
      <el-col
        :span="8"
        class="lead">
        <div>
          <h5>Nuevas Oportunidades</h5>
          <span>{{ opportunities }}</span>
        </div>
      </el-col>
      <el-col
        :span="8"
        class="lead">
        <div>
          <h5>Oportunidades Cerradas</h5>
          <span>{{ close }}</span>
        </div>
        <el-select
          v-model="filterTotalValue"
          @change="calculateLeads()">
          <el-option
            v-for="(filter, index) in filterLead"
            :key="index"
            :label="filter.label"
            :value="filter.value"/>
        </el-select>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment'
import http from '@/services/http.service'
export default {
  name: 'DashboardCards',
  props: {
    year: {
      type: String,
      default: moment().format('YYYY')
    },
    profile: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      arrOpportunities: [],
      arrClose: [],
      filterLead: [
        {
          label: 'Último mes',
          value: 1
        },
        {
          label: 'Últimos 3 meses',
          value: 3
        },
        {
          label: 'Últimos 6 meses',
          value: 6
        },
        {
          label: 'Últimos 9 meses',
          value: 9
        },
        {
          label: 'Últimos 12 meses',
          value: 12
        }
      ],
      filterTotalValue: 1
    }
  },
  computed: {
    profileRole () {
      switch (this.profile.role) {
        case 'superadmin':
          return 'Administración'
        case 'gerente_dealer':
          return 'Distribuidor'
        case 'gerente_branch':
          return 'Sucursal'
        case 'vendedor_dealer':
          return 'Vendedor'
        case 'territorial_agco':
          return 'Territorial'
        default:
          return 'Vendedor'
      }
    },
    initialLetter () {
      return this.profile.name[0]
    },
    opportunities () { // En proceso
      return this.arrOpportunities.length > 0 ? this.arrOpportunities[0].total : 0
    },
    close () { // Aceptada
      return this.arrClose.length > 0 ? this.arrClose[0].total : 0
    },
    day () {
      return moment().format('DD')
    },
    month () {
      return moment().format('MM')
    },
    dealer () {
      let _dealer = 'AGCO Corporation'
      if (this.profile.role === 'gerente_branch' || this.profile.role === 'vendedor') {
        _dealer = this.profile.branch || this.dealer.dealer
      } else {
        _dealer = this.profile.dealer || 'AGCO Corporation'
      }
      return _dealer
    }
  },
  watch: {
    year: function (newYear, oldYear) {
      this.calculateLeads()
    }
  },
  mounted () {
    this.calculateLeads()
  },
  methods: {
    calculateLeads () {
      this.arrOpportunities = []
      this.arrClose = []
      let today = `${this.year}-${this.month}-${this.day}`
      let lastDate = moment(today).subtract(this.filterTotalValue, 'months').format('YYYY-MM-DD')
      http.get(`dashboard/leads/?startDate=${lastDate}&endDate=${today}`)
        .then(({data}) => {
          for (let item of data) {
            if (item.status === 'En Proceso') {
              this.arrOpportunities.push(item)
            }
            if (item.status === 'Aceptada') {
              this.arrClose.push(item)
            }
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
  .header-dash{
    border: 1px solid $border-primary;
    .card{
      border-right: 1px solid $border-primary;
      background-color: #ffffff;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:last-child{
        border-right: 0;
      }
      .el-button{
        min-width: 80px;
        min-height: 80px;
        background-color: $item-logo;
        border: none;
        @include font-secondary(30px, light);
        color: #fff;
        margin-right: 10px;
      }
      .data-item{
        h4{
          margin: 10px 0;
          @include font-lato(16px, bold);
        }
        span, p {
          @include font-primary(12px, regular);
          color: $items-secundary;
        }
      }
    }
    .lead{
      height: 120px;
      border-right: 1px solid $border-primary;
      background-color: #ffffff;
      justify-content: flex-start;
      align-items: flex-start;
      padding-left: 30px;
      position: relative;
      h5{
        @include font-lato(14px, bold);
        color: $header-list;
        margin-bottom: 10px;
      }
      span{
        @include font-primary(36px, light);
        color: $font-title;
      }
      .el-select{
        width: 170px;
        position: absolute;
        right: 0;
        top: 0;
        border: 0px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/modules/dashboard/dashboard-cards.vue